import { type FormItemLayout } from '@framework/form/item/FormItem.tsx';

const inputLayout: FormItemLayout = {
  removeLabelSpace: true,
  hideVisualLabel: true,
};
export const AdvancedSearchFormItemLayout: FormItemLayout = inputLayout;
